export { default as i18next } from './lib/i18n';
export {
  DEFAULT_LANGUAGE_CODE,
  getLanguageOptions,
  type LanguageCode,
  type LanguageOption,
  SUPPORTED_LANGUAGE_CODES,
} from './lib/languages';
